@import 'fluid-currency-field.theme.less';

@import '../../styles/mixins/fluid-form-elements.mixin.less';
@import '../../styles/mixins/fluid-transitions.mixin.less';

// ================================================================ //
// -- Theme Definition

:host {
  display: block;

  *, ::after, ::before {
    box-sizing: border-box;
  }

  .fluid-currency-field {

    /**
     * LEGACY THEME
     */
    &.legacy {
      @import '../../styles/variables-iuw-legacy.less';
      @currency-field-tokens: @currency-field-tokens-legacy;
      @currency-field();
    }

    /**
     * LIBERTY MUTUAL THEME
     */
    &.lm {
      @import '../../styles/variables-lm.less';
      @currency-field-tokens: @currency-field-tokens-lm;
      @currency-field();
    }

    /**
     * LM CORPORATE THEME
     */
    &.corp, &.default {
      @import '../../styles/variables-lm-corp.less';
      @currency-field-tokens: @currency-field-tokens-corp;
      @currency-field();
    }

    /**
     * PORTAL THEME
     */
    &.portal {
      @import '../../styles/variables-lm-portal.less';
      @currency-field-tokens: @currency-field-tokens-portal;
      @currency-field();
    }
  }
}


// ================================================================ //
// -- Component Detached Ruleset

@currency-field: {
  @placeholder: @currency-field-tokens[@placeholder];

  font-family: @font-family;

  .form-group {
    .fluid-form-group();

    .input-wrapper {
      position: relative;

      // == Input Text Alignment

      // TODO: REMOVE ON REFACTOR (Format like Input Field)
      &.text-align-center {
        &:not(:focus-within),
        &.readonly {
          input { text-align: center; }
          .cancel { display: none; }
        }
      }

      &.text-align-right {
        &:not(:focus-within),
        &.readonly {
          input { direction: rtl; }
          .cancel { display: none; }
        }
      } // TODO: END REMOVE

      .cancel {
        position: absolute;
        right: 0.8em;
        top: 50%;
        transform: translateY(-50%);
      }

      input {
        .fluid-input(@currency-field-tokens);
        box-shadow: @currency-field-tokens[box-shadow];

        &::-webkit-input-placeholder { @currency-placeholder-text(); }
        &::-moz-placeholder { @currency-placeholder-text(); }
        &:-moz-placeholder { @currency-placeholder-text(); }
        &:-ms-input-placeholder { @currency-placeholder-text(); }

        &:focus {
          &::-webkit-input-placeholder { @currency-placeholder-text-focus(); }
          &::-moz-placeholder { @currency-placeholder-text-focus(); }
          &:-moz-placeholder { @currency-placeholder-text-focus(); }
          &:-ms-input-placeholder { @currency-placeholder-text-focus(); }
        }

        // == Stepper Buttons (i.e. "Spin Buttons")

        .stepper-buttons();

        // TODO: REMOVE ON REFACTOR
        &::-webkit-inner-spin-button {
          margin-left: 0 !important;
          margin-right: 0 !important;
        } // TODO: END REMOVE
      }

      .fluid-pseudo-style(input, @currency-field-tokens);
    }
  }
};


// ================================================================ //
// -- Utility Detached Ruleset(s)

@currency-placeholder-text: {
  font-size: @placeholder[font-size];
  font-weight: @placeholder[font-weight];
  text-align: @placeholder[text-align];
  color: @placeholder[text-color];
  padding-right: @currency-field-tokens[text-indent];

  .transition(@property: color, opacity, visibility; @duration: short);
};

@currency-placeholder-text-focus: {
  color: transparent;
  opacity: 0;
  visibility: hidden;
};
